// Portal env validation. Vite exposes `import.meta.env.VITE_*` at build
// time; we Zod-parse those so a misconfigured build fails at boot with a
// clear message.

import { z } from 'zod';

const EnvSchema = z.object({
  VITE_MSAL_TENANT_ID: z.string().uuid().default('00000000-0000-0000-0000-000000000000'),
  VITE_MSAL_CLIENT_ID: z.string().uuid().default('00000000-0000-0000-0000-000000000000'),
  VITE_MSAL_API_SCOPE: z.string().default('api://ionic-hr-automations-placeholder/access_as_user'),
  VITE_API_BASE_URL: z.string().url().default('http://localhost:8080'),
});

export type Env = z.infer<typeof EnvSchema>;

export const env: Env = (() => {
  const parsed = EnvSchema.safeParse(import.meta.env);
  if (!parsed.success) {
    const lines = parsed.error.errors.map((e) => `  ${e.path.join('.') || '(root)'}: ${e.message}`);
    throw new Error(`Portal env validation failed:\n${lines.join('\n')}`);
  }
  return parsed.data;
})();
